import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
import Items from "../Items.js";
export default class ProfileController {

  constructor(app) {
    this.app = app;
    this.model = {};
    this.gamification = app.gamification;
  }
  show(path, model) {
    this.load();

    const swapPage = new SwapPage();
    swapPage.swapPage("Profile");
  }
  populate(model) {
    const pageId = "Profile";
    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);
  }
  load() {
    const app = this.app;
    const config = app.config;
    const userdata = app.userdata;
    const items = app.items;


    const coins = userdata.coins;
    const isLoggedIn = Boolean(userdata.facebooktoken);
    const gameServerPreferred = userdata.gameServerPreferred;
    let deckIcon = "";

    let item = items.getItem(userdata.deck);
    if (item) deckIcon = item.icon;

    //get servers
    this.gamification.GetGameServers().then((servers) => {
      const gameServers = servers || [];
      gameServers.unshift({ Url: "", Name: "Auto" });
      //gameServers.push({ Url: "http://192.168.1.12", Name: "Test"});

      for (let i = 0; i < gameServers.length; i++) {
        let gameServer = gameServers[i];
        gameServer.Selected = (gameServer.Url === gameServerPreferred);
      }
      this.model.gameServers = gameServers;
      this.populate(this.model);
    });

    let gameServers = (config.GameServers || []).map(i => { return { Url: i, Name: i } });
    gameServers.unshift({ Url: null, Name: "Auto" });
    //gameServers.push({ Url: "http://192.168.1.12", Name: "Test"});
    for (let i = 0; i < gameServers.length; i++) {
      let gameServer = gameServers[i];
      gameServer.Selected = (gameServer.Url === gameServerPreferred);
    }
    //get languages
    const languages = [""].concat(app.localization.getSupportedLanguages());
    const languagesModel = languages.map(lang => {
      return {
        language: lang,
        selected: lang === userdata.language || (lang === "" && !userdata.language),
        label: lang === "" ? "Auto" : lang
      };
    });

    const showLogin = !config.hideLogin;

    this.model = {
      coins: coins,
      userdata: userdata,
      isLoggedIn: isLoggedIn,
      deckIcon: deckIcon,
      gameServers: gameServers,
      showLogin: showLogin,
      showEmail: showLogin,
      languages: languagesModel
    };

    this.populate(this.model);
  }
  save(formData) {
    const app = this.app;
    const userdata = app.userdata;

    const name = formData.get('name');
    const quality = formData.get('quality');
    const gameServer = formData.get('gameServerPreferred');
    const isMuted = formData.get('isMuted');
    const useCanvas = formData.get('useCanvas');
    const language = formData.get('language');

    userdata.name = name;
    userdata.quality = quality;
    userdata.gameServerPreferred = gameServer;
    userdata.isMuted = isMuted == "on";
    userdata.useCanvas = useCanvas == "on";
    userdata.language = language;

    if(language){
      app.resource = app.localization.getResource(language);
    }

    app.save();

    window.location = '#/';
  }
  restoreData() {
    const app = this.app;
    const userdata = app.userdata;
    const gamification = app.gamification;
    if (!userdata.id) {
      app.showToast("Can't find user data.  You are not logged in.  Please login and try again.");
      return;
    }

    gamification.GetUserData(userdata.id).then((data) => {
      if (!data) {
        app.showToast("No data found");
        //alert("No data found");
      }
      app.userdata = data;
      this.load(); //update page 
      app.showToast("Updated");
      //alert("No data found");
    });


  };
  deleteDataAsk() {

    let model = {
      message: "This will delete all your data.  Are you sure?",
      yesCommand: "app.controllers['Profile'].deleteData()",
      noCommand: "",
      yes: 'Yes',
      no: 'No'
    }
    const dataBinder = new DataBinder();
    dataBinder.createAndShow("yesNoTemplate", model);
  }
  deleteData() {
    const app = this.app;
    const isOnFacebook = app.isOnFacebook;

    app.userdata = {
      rank: '',
      rating: '',
      coins: 0,
    };
    app.save(true);


    if (app.config.autoLogin) {
      app.loadData();
    }
    else{
      window.location = "#/Login";
    }
    
  };
}